import React, { useState } from 'react';

const BeforeAfterSlider = ({ beforeImage, afterImage }) => {
    // Sets the slider directly in the middle on load
    const [sliderPosition, setSliderPosition] = useState(50);

    const handleSliderChange = (e) => {
        setSliderPosition(e.target.value);
    };

    return (
        <div className="relative w-full max-w-4xl mx-auto aspect-video rounded-xl overflow-hidden shadow-2xl">
            {/* After Image (Base Layer - sits on the bottom) */}
            <img
                src={afterImage}
                alt="After construction"
                className="absolute inset-0 w-full h-full object-cover pointer-events-none"
            />

            {/* Before Image (Top Layer - gets clipped by the slider state) */}
            <img
                src={beforeImage}
                alt="Before construction"
                className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
            />

            {/* Visual Slider Line & Handle */}
            <div
                className="absolute top-0 bottom-0 w-1 bg-white pointer-events-none"
                style={{ left: `calc(${sliderPosition}% - 2px)` }}
            >
                {/* The grab circle in the middle */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg border-2 border-gray-200">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-gray-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7h.01M12 7h.01M16 7h.01M8 12h.01M12 12h.01M16 12h.01M8 17h.01M12 17h.01M16 17h.01"
                        />
                    </svg>
                </div>
            </div>

            {/* Invisible HTML Range Input (This is what the user actually drags) */}
            <input
                type="range"
                min="0"
                max="100"
                value={sliderPosition}
                onChange={handleSliderChange}
                className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-10"
            />
        </div>
    );
};

export default BeforeAfterSlider;